import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { withAnalytics } from '../with-analytics';
import { onDismissed } from '../events';
export var DialogDismissedHandlerComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(DialogDismissedHandlerComponent, _React$Component);
  var _super = _createSuper(DialogDismissedHandlerComponent);
  function DialogDismissedHandlerComponent() {
    _classCallCheck(this, DialogDismissedHandlerComponent);
    return _super.apply(this, arguments);
  }
  _createClass(DialogDismissedHandlerComponent, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        onDialogClosed = _this$props.onDialogClosed,
        isExpanded = _this$props.isExpanded;
      if (prevProps.isExpanded && !isExpanded) {
        onDialogClosed();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return DialogDismissedHandlerComponent;
}(React.Component);
export var DialogDismissedHandler = withAnalytics({
  onDialogClosed: onDismissed
})(DialogDismissedHandlerComponent);